import { Col, Row, Typography } from 'antd';
import { useEffect } from 'react';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import CustomCard from '../../../components/Antd/Card';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomLink from '../../../v2-components/Antd/Link';
import Pharmacies from '../../../v2-components/Pharmacies';
import { platformNames } from '../constants/platform-names.contants';
import { useAdminCarouselStore } from '../store/useCarouselStore';
import { selectOptionsMarket } from './constants/select-options-marketplace.constant';
import { selectOptions } from './constants/select-options.constant';
import { Service } from './service';
import './style.scss';

export default function AdminCarouselPage() {
	const [pharmacy, root_pharmacy, platform, setPharmacy, setRootPharmacy, setData, setPlatform] = useAdminCarouselStore((state) => [
		state.pharmacy,
		state.root_pharmacy,
		state.platform,
		state.setPharmacy,
		state.setRootPharmacy,
		state.setData,
		state.setPlatform,
	]);
	console.log('platform', platform);

	useEffect(() => {
		if (pharmacy) {
			new Service()
				.getCarousel('carousel', pharmacy, root_pharmacy)
				.then((response) => {
					setData(response.data);
				})
				.catch((error) => {
					console.log('error', error);
				});
		}
	}, [pharmacy, root_pharmacy, setData]);

	const handleSelectChange = (e) => {
		setRootPharmacy(e);
		setPharmacy(null);
		if (e === platformNames.pharol) {
			setPlatform(platformNames.mkt);
		} else {
			setPlatform(platformNames.ecc);
			setPharmacy(e);
		}
	};

	const handleSelectChangeMarket = (e) => {
		setPharmacy(e);
	};

	return (
		<div className="admin-carousels">
			<h1>Configuración de carrouseles</h1>
			<Row className="admin-carousel-selects-container">
				<Typography>Plataforma</Typography>
				<Pharmacies
					className="custom-pharmacies"
					options={selectOptions[Enviroment.COUNTRY]}
					onChange={handleSelectChange}
					value={root_pharmacy}
					placeholder="Seleccionar plataforma"
				/>
			</Row>
			{root_pharmacy === platformNames.pharol && (
				<Row className="admin-carousel-selects-container">
					<Typography>Tipo de página</Typography>
					<Pharmacies
						className="custom-pharmacies"
						options={selectOptionsMarket[Enviroment.COUNTRY]}
						onChange={handleSelectChangeMarket}
						value={pharmacy}
						placeholder="Seleccionar tipo de página"
					/>
				</Row>
			)}
			{pharmacy ? (
				<>
					<h2>Seleccionar página a editar</h2>
					<Row>
						{pharmacy !== platformNames.pharol && platform !== platformNames.ecc ? (
							<Col md={12} xs={24}>
								<CustomLink className="card-link-carousel" to={`/admin-carousel/detail`}>
									<CustomCard
										className="carousel-cards"
										title={
											<div className="card-header-container">
												<h3>Corner {pharmacy.toUpperCase()}</h3>
												<div className="inner-container">
													<p>1 elemento configurable</p>
												</div>
											</div>
										}
									>
										<CustomImage
											preview={false}
											src={'https://storage.googleapis.com/tirx-resources-production/6c5f1634-3050-4abd-b943-34523b61bd47.webp'}
											alt="img"
										/>
									</CustomCard>
								</CustomLink>
							</Col>
						) : (
							<Col md={12} xs={24}>
								<CustomLink className="card-link-carousel" to={`/admin-carousel/detail`}>
									<CustomCard
										className="carousel-cards"
										title={
											<div className="card-header-container">
												<h3>Home</h3>
												<div className="inner-container">
													<p>{platform === platformNames.ecc ? '1 elemento configurable' : '2 elementos configurables'}</p>
												</div>
											</div>
										}
									>
										<CustomImage
											src={'https://storage.googleapis.com/tirx-resources-production/6c5f1634-3050-4abd-b943-34523b61bd47.webp'}
											preview={false}
											alt="img"
										/>
									</CustomCard>
								</CustomLink>
							</Col>
						)}
					</Row>
				</>
			) : (
				!root_pharmacy && <h2>Elija una plataforma para ver las páginas editables</h2>
			)}
		</div>
	);
}
